import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/Navbar/Navbar";
import DetailedPost from "../components/Posts/DetailedPost";
import RelatedPosts from "../components/RelatedPosts/RelatedPosts";
import { fetchPost } from "../features/post/postSlice";

export default function Post() {
  const { post, isLoading, isError, error } = useSelector(
    (state) => state.post
  );
  const dispatch = useDispatch();
  const { postId } = useParams();

  useEffect(() => {
    dispatch(fetchPost(postId));
  }, [dispatch, postId]);

  const { id, tags } = post || {};

  // decide what to render
  let content = null;
  if (isLoading) content = <main className="post"><div className="col-span-12">Loading...</div></main>;

  if (!isLoading && isError)
    content = <main className="post"><div className="col-span-12">{error}</div></main>;

  if (!isLoading && !isError && !post?.id) {
    content = <main className="post"><div className="col-span-12">No post found!</div></main>;
  }

  if (!isLoading && !isError && post?.id) {
    content = (
      <>
        <DetailedPost post={post} />
      </>
    );
  }
  return (
    <>
      <Navbar />
      <div className="container mt-8">
        <Link
          to="/"
          className="inline-block text-gray-600 home-btn"
          id="lws-goHome"
        >
          <i className="mr-2 fa-solid fa-house"></i>Go Home
        </Link>
      </div>
      <section className="post-page-container">
        {content}

        <RelatedPosts currentPostId={id} tags={tags} />
      </section>
    </>
  );
}
